import { AloftArea, AloftPrice } from '@aloft/toolkit-shared';

import { Flex } from '../../../summary/components/Flex.js';
import { Td } from '../../../summary/components/Td.js';
import { Tr } from '../../../summary/components/Tr.js';
import { Typography } from '../../../summary/components/Typography.js';
import { COST_APPROACH_COLUMN_WIDTHS } from '../constants.js';

export const CostApproachSummarySectionsRow = ({
  label,
  row,
  onlyShowCostPerSqft = false,
  showBlankData = false,
}: {
  label: string;
  row:
    | {
        sqft?: AloftArea;
        costPerSqft?: AloftPrice;
        totalCost?: AloftPrice;
      }
    | undefined;
  onlyShowCostPerSqft: boolean;
  showBlankData: boolean;
}) => (
  <Tr>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[0]} isFirstColumn={true}>
      <Typography variant="body1">{label}</Typography>
    </Td>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[1]} colSpan={3}>
      {onlyShowCostPerSqft || showBlankData ? undefined : (
        <Typography variant="body1">{row?.sqft?.toString() ?? ''}</Typography>
      )}
    </Td>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[2]} colSpan={3}>
      {showBlankData ? undefined : (
        <Typography variant="body1">
          {row?.costPerSqft ? `${row.costPerSqft.toString()} per sqft` : ''}
        </Typography>
      )}
    </Td>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[3]}>
      <Flex justifyContent="flex-end">
        {onlyShowCostPerSqft || showBlankData ? undefined : (
          <Typography textAlign="right" variant="body1">
            {row?.totalCost ? `= ${row.totalCost.toString(true)}` : ''}
          </Typography>
        )}
      </Flex>
    </Td>
  </Tr>
);
